<template>
  <div class="record">
    <a-spin :spinning="applySpinning">
      <div class="record-content">
        <table class="table" v-if="list">
          <tr>
            <th>申请课程</th>
            <th style="min-width: 190px;">申请时间</th>
            <th style="min-width: 90px;">状态</th>
            <th style="text-align: center;min-width: 90px">操作</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{ item.applyCourse }}</td>
            <td>{{ item.applyTime }}</td>
            <td>
              {{ statusArray[item.reviewStatus] }}
              <span
                v-if="item.reviewStatus == 4"
                style="color: red; margin-left: 4px"
                >请删除后重新申请</span
              >
            </td>
            <td style="text-align: center">
              <span class="detail" @click="gotoDetail(item.id)">详情</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item.id)"
              >
                <span
                  v-if="item.reviewStatus == 1 || item.reviewStatus == 4"
                  class="detail"
                  >删除</span
                >
              </a-popconfirm>
            </td>
          </tr>
        </table>

        <div
          v-else
          style="text-align: center; width: 100%; margin-left: 0; color: #666"
        >
          <span>暂无数据!</span>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          show-quick-jumper
          :default-current="1"
          :total="total"
          :current="pageNo"
          :pageSize="pageSize"
          @change="onChange"
        />
      </div>
    </a-spin>
    <a-modal
      title="审批详情"
      :visible="visible"
      @cancel="visible = false"
      width="1000px"
      :maskClosable="false"
      :bodyStyle="{ padding: '16px' }"
      :okButtonProps="{ style: { display: 'none' } }"
    >
      <div>
        <a-descriptions title="" bordered size="middle">
          <a-descriptions-item label="申请时间">
            {{ detail.applyTime }}
          </a-descriptions-item>
          <a-descriptions-item label="申请课程" :span="2">
            {{ detail.applyCourse }}
          </a-descriptions-item>
          <a-descriptions-item label="申请事由" :span="3">
            {{ detail.applyReason }}
          </a-descriptions-item>
          <a-descriptions-item label="附件" :span="3">
            <div v-if="detail.docList && detail.docList.length > 0">
              <div
                class="file-item"
                v-for="(item, index) in detail.docList"
                :key="index"
              >
                <a
                  :href="item.docUrl"
                  @click.prevent="
                    () => handleDownFile(item.docUrl, item.docName)
                  "
                >
                  <div class="file-item-box">
                    <div class="file-name">{{ item.docName }}</div>
                  </div>
                </a>
              </div>
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="审批状态" :span="3">
            {{ statusArray[detail.reviewStatus] }}
          </a-descriptions-item>
          <a-descriptions-item label="教学点审核时间">
            {{ detail.siteReviewTime }}
          </a-descriptions-item>
          <a-descriptions-item label="教学点审核人">
            {{ detail.siteReviewBy }}
          </a-descriptions-item>
          <a-descriptions-item label="教学点审核意见">
            {{ detail.siteReviewRemark }}
          </a-descriptions-item>
          <a-descriptions-item label="学校审核时间">
            {{ detail.eduReviewTime }}
          </a-descriptions-item>
          <a-descriptions-item label="学校审核人">
            {{ detail.eduReviewBy }}
          </a-descriptions-item>
          <a-descriptions-item label="学校审核意见">
            {{ detail.eduReviewRemark }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "record",
  data: function () {
    return {
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      detail: {},
      applySpinning: false,
      statusArray: [
        "待提交",
        "待审核",
        "审核通过",
        "教学点审核通过",
        "审核驳回",
      ],
      visible: false,
      currentId: "",
    };
  },
  methods: {
    getList() {
      const params = {
        type: "delay_exam",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.applySpinning = true;
      this.axios
        .get(`/biz/home/apply/list`, {
          params,
        })
        .then((res) => {
          if (res.success) {
            this.list = res.result.records;
            this.total = res.result.total;
          }
        })
        .finally(() => {
          this.applySpinning = false;
        });
    },
    onChange(index) {
      this.pageNo = index;
      this.getList();
    },
    getDetail(id) {
      const params = {
        id,
      };
      this.axios
        .get(`/biz/home/apply/detail`, {
          params,
        })
        .then((res) => {
          if (res.success) {
            this.detail = res.result;
          }
        });
    },
    gotoDetail(id) {
      this.currentId = id;
      this.visible = true;
      this.getDetail(id);
    },
    handleDelete(id) {
      this.axios.get(`/biz/home/apply/delete?id=${id}`).then((res) => {
        if (res.success) {
          this.getList();
          this.$message.success(res.message);
        }
      });
    },
    handleDownFile(url, docName) {
      const res = docName.split(".").pop();
      const imgTypes = [
        "bmp",
        "jpg",
        "jpeg",
        "png",
        "gif",
        "svg",
        "webp",
        "BMP",
        "JPG",
        "JPEG",
        "PNG",
        "GIF",
        "SVG",
        "pdf",
        "PDF",
        "txt",
        "TXT",
      ];
      if (imgTypes.includes(res)) {
        window.open(url, "_blank");
      } else {
        window.open(url, "_self");
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.record {
    padding: 28px;
    margin-top: 20px;
    background-color #fff
}
.pagination {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
  }
  .detail{
    color: $bgColor;
    cursor: pointer;
  }
  .file-item-box {
    display: flex;
    gap : 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/examPostTabs/record.vue